<div class="header">
  <div class="grid-row grid-row--nog grid-row--aic">
    <div class="grid-col grid-col--auto">
      <div class="logo logo--outlined">
        <aiwyn-logo [showInternalLogo]="true" [height]="50"></aiwyn-logo>
      </div>
    </div>

    <div class="grid-col">
    </div>

    <!-- TODO: transform this in a component to avoid duplication -->
    <!-- No Contact Support here, deliberately, and unlike the header it is not flag-gated:
         this surface is anonymous by construction (OpenPortalGuard redirects signed-in
         clients to /main) and the support form's endpoint needs a verified contact session,
         so there is nothing here to open it with. The mailto this replaced addressed
         support@aiwyn.ai rather than the firm. Knowledge Base is the self-serve path. [AIW-1852] -->
    <div class="help-menu">
      <button class="user-nav__toggle" [matMenuTriggerFor]="help">
        <div class="help-menu-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9ZM7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.22289 4.22289C4.61341 3.83236 5.24658 3.83236 5.6371 4.22289L9.8771 8.46289C10.2676 8.85341 10.2676 9.48658 9.8771 9.8771C9.48658 10.2676 8.85341 10.2676 8.46289 9.8771L4.22289 5.6371C3.83236 5.24658 3.83236 4.61341 4.22289 4.22289Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1229 14.1229C14.5134 13.7324 15.1466 13.7324 15.5371 14.1229L19.7771 18.3629C20.1676 18.7534 20.1676 19.3866 19.7771 19.7771C19.3866 20.1676 18.7534 20.1676 18.3629 19.7771L14.1229 15.5371C13.7324 15.1466 13.7324 14.5134 14.1229 14.1229Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.7771 4.22289C20.1676 4.61341 20.1676 5.24658 19.7771 5.6371L15.5371 9.8771C15.1466 10.2676 14.5134 10.2676 14.1229 9.8771C13.7324 9.48658 13.7324 8.85341 14.1229 8.46289L18.3629 4.22289C18.7534 3.83236 19.3866 3.83236 19.7771 4.22289Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M19.0671 4.93291C19.4576 5.32343 19.4576 5.9566 19.0671 6.34712L15.5371 9.87712C15.1466 10.2676 14.5134 10.2676 14.1229 9.87712C13.7324 9.4866 13.7324 8.85343 14.1229 8.46291L17.6529 4.93291C18.0434 4.54238 18.6766 4.54238 19.0671 4.93291Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M9.8771 14.1229C10.2676 14.5134 10.2676 15.1466 9.8771 15.5371L5.6371 19.7771C5.24658 20.1676 4.61341 20.1676 4.22289 19.7771C3.83236 19.3866 3.83236 18.7534 4.22289 18.3629L8.46289 14.1229C8.85341 13.7324 9.48658 13.7324 9.8771 14.1229Z" fill="currentColor"/>
          </svg>
        </div>
        <span class="user-nav__name">Help</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="8" viewBox="0 0 12 12" preserveAspectRatio="none"
             class="user-nav__arrow">
          <path fill="currentColor"
                d="M11.5,2H.5a.5.5,0,0,0-.412.783l5.5,8a.5.5,0,0,0,.824,0l5.5-8A.5.5,0,0,0,11.5,2Z"></path>
        </svg>
      </button>
      <mat-menu #help="matMenu" class="header-drop">
        <a class="user-nav__link" href="https://aiwynhelp.zendesk.com/hc/en-us" target="_blank">
          <div class="help-menu-icon">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z" fill="currentColor"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12 11C12.5523 11 13 11.4477 13 12V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V12C11 11.4477 11.4477 11 12 11Z" fill="currentColor"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11 8C11 7.44772 11.4477 7 12 7H12.01C12.5623 7 13.01 7.44772 13.01 8C13.01 8.55228 12.5623 9 12.01 9H12C11.4477 9 11 8.55228 11 8Z" fill="currentColor"/>
            </svg>
          </div>
          Knowledge Base
        </a>


        <div class="d-flex flex-column ps-10 pe-4 pt-1 background-color-white">
          <p class="small-300 my-1">Aiwyn {{ version$ | async }}</p>

          <button
            andButton
            color="hyperlink"
            size="small"
            role="link"
            class="color-gray-400 px-0 w-fit-content fw-light"
            (click)="legalService.openTermsAndConditions()"
          >
            Terms of Service
          </button>

          <button
            andButton
            color="hyperlink"
            size="small"
            role="link"
            class="color-gray-400 px-0 w-fit-content fw-light"
            (click)="legalService.openPrivacyPolicy()"
          >
            Privacy Policy
          </button>
        </div>
      </mat-menu>
    </div>
  </div>
</div>

<div class="content-body">
  <div class="payment-sidebar">
    <div #scrollContent class="d-flex flex-column p-6 payments-sidebar-scroll-content">
      <div *ngIf="isPaymentProcessing$ | async" class="payment-processing-overlay"></div>

      <div class="d-flex align-items-center mb-4">
        <h1>Make a payment to {{ firmName }}</h1>
      </div>

      <!-- If the client is provided, show the client autocomplete and hide the company name field -->
      <div class="d-block" *ngIf="clientProvided$ | async; else companyNameTemplate">
        <label class="color-gray-300 h4-500">Client</label>
        <auto-complete
          [formControl]="clientIdControl"
          [options]="loadedClients$ | async"
          [triggerDisplayFn]="clientAcDisplayFn"
          [compareToFn]="compareClientFn"
          class="mb-4 mt-2 d-block"
            data-cy="clients-autocomplete"
          ></auto-complete>
      </div>

      <ng-template #companyNameTemplate>
        <label class="color-gray-300 h4-500">Company or Individual name</label>
        <input
          class="form-input mt-2"
          [formControl]="companyOrIndividualNameControl"
          [ngClass]="{'form-input--invalid': companyOrIndividualNameControl.invalid && (companyOrIndividualNameControl.touched || companyOrIndividualNameControl.dirty)}"
        />
        <span
          *ngIf="companyOrIndividualNameControl.invalid && (companyOrIndividualNameControl.touched || companyOrIndividualNameControl.dirty)"
          class="small-300 color-red-200 mt-2">
            Company or Individual name is required.
        </span>
      </ng-template>


      <!-- When email-first checkout is on, the email moves down to group with the payment methods
           (see below); this original placement is only used when the flag is off. -->
      @if (!(isRequireEmailBeforePaymentEnabled$ | async)) {
        <app-recipient-emails
          class="mb-4 mt-2"
          [primaryEmail]="primaryEmail"
          [disabled]="recipientEmailDisabledState()"
          (primaryEmailChanged)="onPrimaryEmailChanged($event)"
          (additionalEmailsChanged)="onAdditionalEmailsChanged($event)"
        ></app-recipient-emails>
      }

      <label class="color-gray-300 h4-500">Amount</label>
      <input
        maxlength="11"
        aria-labelledby="payment-amount-label"
        [formControl]="amountControl"
        class="form-input form-input--amount mt-2"
        currencyMask
        [options]="{ prefix: '$', align: 'right', allowNegative: 'false' }"
      >
      <p class="small-300 mt-2 mb-4 color-gray-400" dataSelector="qpl-amount-hint">
        @if (amountControl.disabled) {
          Set by {{ firmName }} for this request.
        } @else {
          Enter the amount you were asked to pay.
        }
      </p>

      <label class="color-gray-300 h4-500">Payment description</label>
      <input
        class="form-input mt-2"
        [formControl]="paymentDescriptionControl"
        [ngClass]="{'form-input--invalid': paymentDescriptionControl.invalid && (paymentDescriptionControl.touched || paymentDescriptionControl.dirty)}"
      />
      <span
        *ngIf="paymentDescriptionControl.invalid && (paymentDescriptionControl.touched || paymentDescriptionControl.dirty)"
        class="small-300 color-red-200 mt-2"
      >
        Payment description is required.
      </span>

      <mat-checkbox [formControl]="termsCheckboxControl" class="my-4 mt-4" data-cy="terms-and-conditions">
        Agree to Aiwyn's
        <a [href]="configService.paymentTermsOfServiceURL" target="_blank">Terms of Service</a>
        and
        <a href="https://www.aiwyn.ai/privacy-policy" target="_blank">Privacy Policy</a>
      </mat-checkbox>

      <span class="small-300">{{ firmName }} partners with Aiwyn for invoicing and payments.</span>

      <!-- Email-first checkout (flag: enable_require_email_address_before_payment_method). When on, the
           email + methods are grouped under "Payment Information" and the methods stay locked until a valid
           email is entered. The rest of this form (amount, description, terms) is unchanged. Off = original. -->
      @if (isRequireEmailBeforePaymentEnabled$ | async) {
        <h4 class="mt-6 mb-2" dataSelector="payment-information-header">Payment Information</h4>

        <app-recipient-emails
          class="mt-2"
          [primaryEmail]="primaryEmail"
          [disabled]="recipientEmailDisabledState()"
          (primaryEmailChanged)="onPrimaryEmailChanged($event)"
          (additionalEmailsChanged)="onAdditionalEmailsChanged($event)"
          (isValid)="onEmailValidChanged($event)"
          (primaryEmailPrepopulated)="onPrimaryEmailPrepopulated($event)"
        >
          <app-select-payment-method
            class="d-block mt-4"
            [showHeader]="false"
            [emailGateActive]="true"
            [emailGateLocked]="!emailValid()"
            [emailGatePrepopulated]="emailGatePrepopulated()"
            [intent]="PaymentMethodIntent.PAYMENT"
            [paymentFlow]="PaymentFlow.STANDARD"
            [paymentMethodMode]="paymentMethodMode$ | async"
            [canSetDefaultPaymentMethodMode]="true"
            [selectedPaymentMethodId]="selectedPaymentMethodId$ | async"
            [surface]="'payments-sidebar-quick-payment-link'"
            (paymentMethodModeChange)="onPaymentMethodModeChange($event)"
            (paymentMethodSelected)="onPaymentMethodSelected($event)"
            (lockedNewMethodAttempt)="onLockedPaymentMethodClick()"
          ></app-select-payment-method>
        </app-recipient-emails>
      } @else {
        <app-select-payment-method
          class="mt-6"
          [intent]="PaymentMethodIntent.PAYMENT"
          [paymentFlow]="PaymentFlow.STANDARD"
          [paymentMethodMode]="paymentMethodMode$ | async"
          [canSetDefaultPaymentMethodMode]="true"
          [selectedPaymentMethodId]="selectedPaymentMethodId$ | async"
          [surface]="'payments-sidebar-quick-payment-link'"
          (paymentMethodModeChange)="onPaymentMethodModeChange($event)"
          (paymentMethodSelected)="onPaymentMethodSelected($event)"
        ></app-select-payment-method>
      }
    </div>

    <div
      class="d-flex flex-column p-6 payments-sidebar-footer"
	    scrollShadow
      [scrollableContent]="scrollContent">
      <app-payment-summary
        [isCustomProcessingFeeEnabled]="false"
        [forceZeroState]="false"
      ></app-payment-summary>

      <button
        andButton
        color="primary"
        size="large"
        [isLoading]="isPaymentProcessing$ | async"
        class="mt-4"
        data-cy="pay-now"
        (click)="onPayNow()"
      >
        <aiwyn-icon name="lock" class="me-2"></aiwyn-icon>
        Pay {{ total$ | async | currency }}
      </button>
    </div>
  </div>
</div>

